import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
let StatisticIndex = class StatisticIndex extends Vue {
    constructor() {
        super();
        this.snackbar = new CBcSnackbar();
        const that = this;
    }
    mounted() {
        const that = this;
    }
};
StatisticIndex = __decorate([
    Component({
        name: 'StatisticIndex',
        components: {
            BcSnackbar,
        },
    })
], StatisticIndex);
export default StatisticIndex;
;
